import { IconButton, Tooltip } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { useIntl } from 'react-intl';
import useDoseVisibility from '~/hooks/dose/useDoseVisibility';

/**
 * Eye-icon dose visibility toggle rendered inside the dose colorwash
 * overlay's title row. Shares state with the sidebar dose-header toggle
 * via `useDoseVisibility`, so the two surfaces never drift.
 *
 * The component renders no backdrop of its own — it inherits the glass
 * overlay from the surrounding `OverlayRow`.
 */
const DoseVisibilityToggle = () => {
    const intl = useIntl();
    const { isDoseVisible, toggleDoseVisibility } = useDoseVisibility();

    const label = intl.formatMessage({
        id: isDoseVisible ? 'hideDose' : 'showDose',
    });

    return (
        <Tooltip title={label}>
            <IconButton
                size="small"
                onClick={toggleDoseVisibility}
                data-testid="dose-visibility-toggle-overlay"
                aria-label={label}
                onPointerDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                sx={{
                    color: 'common.white',
                    padding: 0,
                    lineHeight: 0,
                    '&:hover': {
                        color: 'primary.main',
                        backgroundColor: 'transparent',
                    },
                }}
            >
                {isDoseVisible ? <Eye size={11} /> : <EyeOff size={11} />}
            </IconButton>
        </Tooltip>
    );
};

export default DoseVisibilityToggle;
